(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('invalid', function (event) {
    if (!event.target.matches('[data-buy-consent]')) return;
    event.preventDefault();
    var form = event.target.closest('[data-buy-form]');
    form.classList.remove('is-invalid');
    void form.offsetWidth;
    form.classList.add('is-invalid');
    var error = form.querySelector('[data-buy-error]');
    if (error) error.hidden = false;
    event.target.focus();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-buy-form]');
    if (!form) return;
    var consent = form.querySelector('[data-buy-consent]');
    var error = form.querySelector('[data-buy-error]');
    if (consent && !consent.checked) {
      event.preventDefault();
      form.classList.remove('is-invalid');
      void form.offsetWidth;
      form.classList.add('is-invalid');
      if (error) error.hidden = false;
      consent.focus();
      return;
    }
    var button = form.querySelector('[data-buy-submit]');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-buy-consent]')) return;
    var form = event.target.closest('[data-buy-form]');
    if (!form) return;
    form.classList.remove('is-invalid');
    var error = form.querySelector('[data-buy-error]');
    if (error) error.hidden = true;
    document.querySelectorAll('[data-buy-consent]').forEach(function (box) {
      box.checked = event.target.checked;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-buy"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-buy-form]'));
    var visible = new Set();
    var scrolledPastTop = false;

    function update() {
      var show = scrolledPastTop && visible.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = bar.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      });
      update();
    }, { threshold: 0.2 });
    forms.forEach(function (form) { observer.observe(form); });

    window.addEventListener('scroll', function () {
      var past = window.scrollY > window.innerHeight * 0.6;
      if (past !== scrolledPastTop) { scrolledPastTop = past; update(); }
    }, { passive: true });

    bar.querySelector('[data-sticky-target]').addEventListener('click', function (event) {
      if (!forms.length) return;
      event.preventDefault();
      var target = document.getElementById('acheter') || forms[forms.length - 1];
      var closest = forms.reduce(function (best, form) {
        var distance = Math.abs(form.getBoundingClientRect().top);
        return !best || distance < best.distance ? { form: form, distance: distance } : best;
      }, null);
      var destination = document.getElementById('acheter') ? target : closest.form;
      destination.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var consent = destination.querySelector ? destination.querySelector('[data-buy-consent]') : null;
      setTimeout(function () { if (consent) consent.focus({ preventScroll: true }); }, 500);
    });
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
